// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5754":"ebfaca7b","8036":"30d3a3a5"}[chunkId] + ".chunk.css";
};